import { __spreadArrays } from "tslib";
export var default_options = {
    tala: "I#-O-O",
    jati: 4,
    nadai: 1,
    pitch: "D#",
    noteSets: "P/S",
};
export var MOVEMENT;
(function (MOVEMENT) {
    MOVEMENT["UP"] = "up";
    MOVEMENT["DOWN"] = "down";
})(MOVEMENT || (MOVEMENT = {}));
;
export var get_sequence = function (options) {
    if (options === void 0) { options = default_options; }
    var laghu = function (angas) { return (__spreadArrays([MOVEMENT.UP], Array(angas - 1).fill(MOVEMENT.DOWN))); };
    var dhrita = [MOVEMENT.UP, MOVEMENT.DOWN];
    var anudhrita = [MOVEMENT.UP];
    var sequence = options.tala.split('-').map(function (letter) {
        switch (letter) {
            case 'I1': return anudhrita;
            case 'I2': return dhrita;
            case 'I3': return laghu(3);
            case 'I4': return laghu(4);
            case 'I6': return laghu(6);
            case 'I#': return laghu(options.jati);
            case 'O': return dhrita;
            case 'U': return anudhrita;
        }
    }).flat();
    return sequence;
};
